<template>
  <div class="InfoEdit-body">
    <div class="InfoEdit-body-context">
      <div class="InfoEdit-context-slot">
        <template>
          <slot></slot>
        </template>
      </div>
      <div class="InfoEdit-context-container">
        <div class="InfoEdit-title">
          {{ title }} <div><i class="el-icon-close" @click="close"></i></div>
        </div>
        <div class="InfoEdit-context">
          <div class="InfoEdit-context-div-list">
            <div v-for="(prop, propIndex) in infoProps" :key="propIndex" class="InfoEdit-context-div">
              <div class="InfoEdit-context-text ellipsis-text" :title="prop.name">
                <span v-if="prop.isCheck" class="span-red">*</span>{{ prop.name }}
              </div>
              <!-- input -->
              <div v-if="prop.type == 'date'" class="InfoEdit-context-input">
                <el-date-picker v-model="target[prop.prop]" type="date" placeholder="选择日期">
                </el-date-picker>
              </div>
              <div v-else-if="prop.type == 'datetime'" class="InfoEdit-context-input">
                <el-date-picker v-model="target[prop.prop]" type="datetime" placeholder="选择日期">
                </el-date-picker>
              </div>
              <div v-else-if="prop.type == 'number'" class="InfoEdit-context-input">
                <el-input-number v-model="target[prop.prop]" :label="prop.name" :min="prop.number && prop.number.min">
                </el-input-number>
              </div>
              <div v-else-if="prop.type == 'select'" class="InfoEdit-context-input">
                <el-select v-model="target[prop.prop]" placeholder="请选择" @change="changeFun(prop, $event)"
                  :filterable="prop.select && prop.select.filterable" :multiple="prop.select && prop.select.multiple"
                  :allow-create="prop.select && prop.select.create"
                  @remove-tag="handleRemoveOption(target, prop, $event)">
                  <el-option v-for="(item, selectIndex) in target[prop.select.list]" :key="selectIndex"
                    :label="prop.select.label ? item[prop.select.label] : item"
                    :value="prop.select.value ? item[prop.select.value] : item">
                  </el-option>
                </el-select>
                <el-input class="input-new-option" v-if="tagInputShow[prop.prop]" v-model="tagInputValue[prop.prop]"
                  :ref="tagsRef + '-' + prop.prop" @keyup.enter.native="handleNewOptionConfirm(target, prop)"
                  @blur="handleNewOptionConfirm(target, prop)"></el-input>
                <el-button v-if="prop.addOption && !tagInputShow[prop.prop]" class="button-new-option"
                  @click="showInput(prop)">{{ prop.addName || '新增' }}</el-button>
              </div>
              <div v-else-if="prop.type == 'password'" class="InfoEdit-context-input">
                <el-input v-model="target[prop.prop]" :placeholder="prop.name" show-password></el-input>
              </div>
              <div v-else-if="prop.type == 'textarea'" class="InfoEdit-context-input" :style="{
                width: 'calc(100% - var(--text1Width))',
              }">
                <el-input v-model="target[prop.prop]" :placeholder="prop.name" type="textarea"
                  :autosize="{ minRows: 4 }"></el-input>
              </div>
              <div v-else-if="prop.type == 'verify'" class="InfoEdit-context-input">
                <div class="verify-input">
                  <el-input v-model="target[prop.prop]" :placeholder="prop.name"></el-input>
                  <img :src="target[prop.prop + 'Url']" @click="prop.fun">
                </div>
              </div>
              <div v-else-if="prop.type == 'upload'" class="InfoEdit-context-input"
                style="width: calc(100% - var(--text1Width)); display: inline-flex;">
                <el-upload action="#" :multiple="false" :on-change="(file, fileList) => {
                  prop.fun && prop.fun(file, fileList, target, prop);
                }
                  " :auto-upload="false" :accept="prop.accept" :show-file-list="false" style="width: 100px;">
                  <el-button size="small" type="primary" icon="el-icon-upload2" slot="trigger"
                    :loading="target[prop.load]">文件上传</el-button>
                </el-upload>
                <div style="
                      width: calc(100% - 100px);
                      color: rgb(200, 200, 200);
                      font-size: 14px;
                    " class="ellipsis-text" v-if="target[prop.prop]"
                  :title="target[prop.prop].name || target[prop.prop] || ''">
                  {{ target[prop.prop].name || target[prop.prop] || '' }}
                </div>
              </div>
              <div v-else-if="prop.type == 'tree'" :style="{
                height: '360px',
              }" class="InfoEdit-context-input scroll-y">
                <el-tree show-checkbox default-expand-all :data="target[prop.tree.list]" :ref="prop.prop"
                  :default-checked-keys="target[prop.prop]" :props="prop.tree.props" :node-key="prop.tree.key">
                </el-tree>
              </div>
              <div v-else-if="prop.type == 'tags'" class="InfoEdit-context-tags scroll-y">
                <el-tag :key="tagIndex" v-for="(tag, tagIndex) in (target[prop.prop] || [])" closable
                  :disable-transitions="false" @close="handleClose(tag, target, prop)">
                  {{ tag }}
                </el-tag>
                <el-input class="input-new-tag" v-if="tagInputShow[prop.prop]" v-model="tagInputValue[prop.prop]"
                  :ref="tagsRef + '-' + prop.prop" size="small" @keyup.enter.native="handleInputConfirm(target, prop)"
                  @blur="handleInputConfirm(target, prop)">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput(prop)">+
                  新标签</el-button>
              </div>
              <div v-else class="InfoEdit-context-input">
                <el-input v-model="target[prop.prop]" :placeholder="prop.name"></el-input>
              </div>
              <!--  -->
              <div class="InfoEdit-context-text" v-if="prop.alert"><span class="span-red">*</span>{{
                prop.alert }}
              </div>
            </div>
          </div>
          <div class="InfoEdit-context-button">
            <el-button v-for="(button, buttonIndex) in buttonList" :key="buttonIndex" :type="button.type" size="mini"
              @click="button.fun(target)">{{ button.name }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 组件
  components: {},
  // 组件数据
  props: {
    title: {
      type: String,
      default() {
        return '修改';
      }
    },
    target: {
      type: Object,
      default() {
        return {}
      }
    },
    infoProps: {
      type: Array,
      default() {
        return [];
      }
    },
    buttonList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  // 数据
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',

      tagsRef: 'tagInput',
      tagInputShow: {

      },
      tagInputValue: {

      },
    };
  },
  // 组件启动时
  created() { },
  // 组件启动后
  mounted() { },
  computed: {},
  watch: {},
  // 方法块
  methods: {
    handleClose(tag, target, prop) {
      if (target[prop.prop].indexOf(tag) == -1) return;
      target[prop.prop].splice(target[prop.prop].indexOf(tag), 1);
      this.$forceUpdate();
    },
    showInput(prop) {
      this.$set(this.tagInputShow, prop.prop, true);
      this.$nextTick(_ => {
        if (!this.$refs[`${this.tagsRef}-${prop.prop}`]) {
          return;
        }
        this.$refs[`${this.tagsRef}-${prop.prop}`].at(0).$refs.input.focus();
      });
    },
    handleInputConfirm(target, prop) {
      let inputValue = this.tagInputValue[prop.prop];
      // this.$set(this.tagInputValue, prop.prop, true);
      if (inputValue) {
        if (!target[prop.prop]) {
          target[prop.prop] = [];
        }
        target[prop.prop].push(inputValue);
      }
      this.$set(this.tagInputShow, prop.prop, false);
      this.$set(this.tagInputValue, prop.prop, '');
    },
    changeFun(prop, event) {
      (prop.changeFun || (() => { }))(event);
    },
    handleNewOptionConfirm(target, prop) {
      let inputValue = this.tagInputValue[prop.prop];
      if (inputValue) {
        if (!target[prop.addProp]) {
          target[prop.addProp] = [];
        }
        target[prop.addProp].push(inputValue);
        target[prop.prop].push(inputValue);
      }
      this.$set(this.tagInputValue, prop.prop, '');
      this.$set(this.tagInputShow, prop.prop, false);
    },
    handleRemoveOption(target, prop, removeOption) {
      if (prop.addOption && target[prop.addProp] && target[prop.addProp].length !== 0) {
        if (typeof removeOption === 'string') {
          target[prop.addProp] = target[prop.addProp].filter(option => option !== removeOption);
        }
      }
    },
    close() {
      this.$emit('close');
    }
  },
  // 组件销毁时
  destroyed() { },
};
</script>
<style lang='less'>
.InfoEdit-body {
  div {
    box-sizing: border-box;
  }
  text-align: start;
  .el-upload-list__item-name {
    color: rgb(100, 100, 100);
  }
}

.elTable-button-popover {
  z-index: 3 !important;
  min-width: auto !important;
}
</style>
<style lang='less' scoped>
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.button-new-option {
  margin-left: 10px;
  padding: 12px 15px;
  vertical-align: top;
}

.input-new-tag {
  width: 90px;
  vertical-align: bottom;
}

.input-new-option {
  margin-left: 10px;
  width: 90px;
  vertical-align: top;
}

.el-tag,
.button-new-tag,
.input-new-tag {
  margin-right: 10px;
  margin-bottom: 10px;

  &:last-child {
    margin-right: 0;
  }
}

.InfoEdit-body {
  .el-upload-list__item-name {
    color: #fff;
  }

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(40, 40, 40, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  .InfoEdit-body-context {
    --titleHeight: 40px;
    height: max-content;
    background-color: #2C5364;
    border-radius: 10px;
    display: flex;

    .InfoEdit-context-slot {
      // float: left;
      border-bottom-left-radius: 10px;
    }

    .InfoEdit-context-container {
      // float: left;
      width: 540px;
    }

    .InfoEdit-title {
      padding: 0px 15px;
      height: var(--titleHeight);
      line-height: var(--titleHeight);
      font-size: 22px;
      font-weight: bold;
      background-color: #203A43;
      color: rgb(240, 248, 255);

      div {
        float: right;
        height: var(--titleHeight);
        line-height: var(--titleHeight);

        i {
          cursor: pointer;
        }
      }
    }

    .InfoEdit-context {
      padding: 15px;
      height: max-content;
      width: 100%;
      --InfoEditContextDivHeigth: 24px;

      .InfoEdit-context-div-list {
        max-height: 500px;
        overflow: auto;
        &::-webkit-scrollbar{
          width: 8px; /*对垂直流动条有效*/
          height: 8px; /*对水平流动条有效*/
          border-radius: 10px;
        }
        &::-webkit-scrollbar-track{
          background-color: none;
        }
        &::-webkit-scrollbar-thumb{
          border-radius: 4px;
          -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
          background-color: #2B5161;
        }
      }

      .InfoEdit-context-div {
        // height: var(--InfoEditContextDivHeigth);
        height: max-content;
        width: 100%;
        --inputWidth: 220px;
        --text1Width: 100px;
        --imgWidth: 120px;
        padding: 8px;
        // max-height: 550px;
        // overflow: auto;

        .InfoEdit-context-input {
          width: 100%;
          // height: var(--InfoEditContextDivHeigth);
          height: 100%;
          line-height: var(--InfoEditContextDivHeigth);
          // float: left;
          display: inline-block;

          .verify-input {
            .el-input {
              width: calc(100% - 10px - var(--imgWidth));
              margin-right: 10px;
            }

            img {
              width: var(--imgWidth);
              height: 40px;
              vertical-align: middle;
            }
          }
        }

        .InfoEdit-context-tags {
          width: 100%;
        }

        .InfoEdit-context-text {
          // float: left;
          // display: inline-block;
          color: rgb(250, 235, 215);
          height: var(--InfoEditContextDivHeigth);
          font-size: 12px;
          padding: 0 10px;

          // width: calc(100% - var(--inputWidth) - var(--text1Width));
          &:nth-child(1) {
            // width: var(--text1Width);
            text-align: left;
            line-height: var(--InfoEditContextDivHeigth);
            vertical-align: top;
          }

          &:nth-child(3) {
            line-height: var(--InfoEditContextDivHeigth);
          }
        }

      }

      .InfoEdit-context-button {
        height: 60px;
        line-height: 60px;
        text-align: center;
      }
    }
  }
}
</style>